import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { fetchReservationSuggest } from '@/apis/aipass'
import { ApprovedStatusType } from '@/models/reservation-approved-status'

type ReservationSuggestItem = {
  id: string
  reservationId: string
  checkinId?: string
  approvedStatus: number
}

const getReservationPath = ({ id, reservationId, checkinId, approvedStatus }: ReservationSuggestItem): string => {
  if (approvedStatus === ApprovedStatusType.Checkin && checkinId) {
    return `/checkin/${checkinId}`
  }
  if (approvedStatus === ApprovedStatusType.Stay && checkinId) {
    return `/stay/${checkinId}`
  }
  if (approvedStatus === ApprovedStatusType.Checkout && checkinId) {
    return `/checkout/${checkinId}`
  }
  return `/reservation/${id}?reservationId=${reservationId}`
}

export const ReservationSuggest: React.FC = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    let isUnmounted = false
    const redirectFallback = () => history.replace('/room-manager/daily')

    const execute = async () => {
      const tel = new URLSearchParams(location.search).get('tel')?.trim()
      if (!tel) {
        redirectFallback()
        return
      }

      try {
        const result = await fetchReservationSuggest(tel)
        if (isUnmounted) {
          return
        }
        if (result.reservations.length === 0) {
          redirectFallback()
          return
        }

        const [firstReservation, ...restReservations] = result.reservations
        restReservations.forEach(reservation => {
          window.open(getReservationPath(reservation), '_blank')
        })
        history.replace(getReservationPath(firstReservation))
      } catch (_error) {
        if (isUnmounted) {
          return
        }
        redirectFallback()
      }
    }

    execute()

    return () => {
      isUnmounted = true
    }
  }, [history, location.search])

  return null
}
